export const isSchemaMeeting = (schemaId: string, checkSchedule = true) => {
    return schemaId == 'Meetings' || (checkSchedule ? schemaId == 'MeetingsSchedule' : false);
}

export const isSchemaMeetingSchedule = (schemaId: string) => {
    return schemaId == 'MeetingsSchedule';
}
